import React from 'react';
import { Row, Col, Container, TabsList, TabsV2, TabsTab, TabPanel } from '@si-armes/dsfr-react';
import { connect } from 'react-redux';
import { getAPI, postAPI, reinitialiseAPI } from 'store/apiReducer';
import * as PropTypes from 'prop-types';

import ImporterArme from './components/importerArme';
import Resultats from './components/Resultats';

const ImportArmeEnMasse = ({ dataProfil }) => {
    const numSia = dataProfil?.numeroSia;
    const onglets = [
        {
            titre: 'Importer les armes',
            idAria: 'importer-armes',
            onglet: <ImporterArme numSia={numSia} />,
        },
        {
            titre: 'Résultat(s)',
            idAria: 'resultats',
            onglet: <Resultats numSia={numSia} />,
        },
    ];
    return (
        <Container>
            <Row>
                <Col col={12}>
                    <h1>Ajout d'armes en masse</h1>
                </Col>
            </Row>
            <TabsV2>
                <TabsList label="choix du materiel" id="armes">
                    {onglets.map((onglet) => {
                        return <TabsTab idTab={onglet.idAria}>{onglet.titre}</TabsTab>;
                    })}
                </TabsList>
                {onglets.map((onglet) => {
                    return <TabPanel idTab={onglet.idAria}>{onglet.onglet}</TabPanel>;
                })}
            </TabsV2>
        </Container>
    );
};

ImportArmeEnMasse.propTypes = {
    dataProfil: PropTypes.object.isRequired,
};

export default connect(
    (state) => {
        const { data: dataProfil } = state.profil.usager;

        return {
            dataProfil,
        };
    },
    {
        postApi: postAPI,
        getApi: getAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(ImportArmeEnMasse);
